/**
 * Created by Administrator on 2018/4/12.
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import userIcon from '../../static/images/inituserHead.png'
import blackLogo from '../assets/logo-w.png'
import successRes from '../../static/images/successRes.png'
import failedRes from '../../static/images/failedRes.png'
import logos from '../../static/images/logos.png'
import newRes from '../../static/images/newRes.jpg'

export default new Vuex.Store({
  state: {
    newType:"3",
    shows:"1",
    newDetails:"",
    abouts:"1",

    //如更新api地址，别忘记改 global.vue !!!

     commonip:'https://www.chinesemedicalvolunteers.com:8105',

    exam: {
      successRes: successRes,
      logos: logos,
      failedRes: failedRes,
      newRes: newRes,
    },
    systemInfo: {
      name: '登录',
      blackLogo: blackLogo,
      Copyright: 'Copyright 2018.All rights reserved.',
      CopyrightStr: 'CopyRight © 2018 北京凌锋公益基金会 版权所有 京ICP备18012326号-1',
      beianStr: '京公网安备 11010102005707号',
      navs: [
        {title: '首页', to: '/home', className: 'homeNav'},
        {title: '新闻中心', to: '/newscenter', className: 'newscenterNav'},
        {title: '行动介绍', to: '/intr', className: 'intrNav'},
        {title: '志愿招募', to: '/activelist', className: 'activelist'},
        // {title: '志愿招募', to: '/Login', className: 'Login'},
        {title: '申请援建', to: '/applyState', className: 'applyState'},
        // {title: '募款捐助', to: '/message', className: 'messageNav'},
        {title: '课程培训', to: '/training', className: 'trainingNav'},
        {title: '关于我们', to: '/aboutUs', className: 'aboutUs'},
        {title: 'APP下载', to: '/download', className: 'downloadNav'},
      ],
      footerNavs: [
        {title: '联系我们', to: '/home'},
        {title: '关于我们', to: '/home'},
        {title: '隐私条款', to: '/home'},
        {title: '免责声明', to: '/home'}],
    },
    loginRuler: {
      name: '未命名',
      icon: userIcon,
    },
    isLogin: true,
    isRegist: false,
  },
  getters: {
    getLoginRuler: () => {
      return user
    },
  },
  actions: {
    setLoginState: (context, obj) => {
      context.commit('setLoginState', obj)
    },
    setRegistState: (context, obj) => {
      context.commit('setRegistState', obj)
    },
    setUser: (context, obj) => {
      context.commit('setUser', obj)
    }
  },
  mutations: {
    reverseAbout(state,data){
      state.abouts=data
    },
    reversShow(state,data){
      state.shows=data
    },
    amend(state,data){
      state.newDetails=data.content
    },
    reverse(state,data){
      state.newType=data
    },

    setLoginState: (state, obj) => {
      state.isLogin = obj.flag;
    },
    setRegistState: (state, obj) => {
      state.isRegist = obj.flag;
    },
    setUser: (state, obj) => {
      if (obj.name) {
        state.loginRuler.name = obj.name;
      }
      if (obj.icon) {
        state.loginRuler.icon = obj.icon;
      }
    },

  }
})



// WEBPACK FOOTER //
// ./src/store/store.js